import { removeTagAndContents } from "./removeTag.js";

export function parseMapToDOM(currentMap) {
  const parser = new DOMParser();
  const cleanMap = removeTagAndContents(currentMap, "related-links");
  const cleaned = cleanMap.replace(/&nbsp;/g, ' '); // or '\u00A0'
  const xmlParsed = parser.parseFromString(cleaned, "text/xml");
  return xmlParsed;
}

export function DOMtoString(xmlParsed) {
  const serializer = new XMLSerializer();
  const xmlString = serializer.serializeToString(xmlParsed);
  return xmlString;
}